export default function IsEmpty(obj: Record<string, any>) {
  for (const k in obj) {
    const v = obj[k];
    if (Object.prototype.hasOwnProperty.call(obj, k) && !!v) {
      return false;
    }
  }
  return true;
}
